import { z } from 'zod';
import { validatedGet, validatedPost, validatedDelete, apiPost } from '../api-client.ts';
import { CassaCodeSchema } from '@/types/entities/index.ts';
import { ElaborazioneResponseSchema } from '@/types/api-responses.ts';
import type { CassaCode } from '@/types/entities/index.ts';
import { OkResult } from './shared.ts';

const ElaborazioniListResult = z.object({
  elaborazioni: z.array(ElaborazioneResponseSchema),
  count: z.number(),
});

const CreaResult = z.object({
  id: z.number(),
  cassa: CassaCodeSchema,
  anno: z.number(),
  mese: z.number(),
  stato: z.literal('IN_CORSO'),
});

const TipiCassaResult = z.array(z.object({
  codice: z.string(),
  label: z.string(),
}));

const UploadFeniceResult = z.object({
  ok: z.literal(true),
  id_job: z.number(),
});

export const elaborazioniApi = {
  lista: (cassa?: CassaCode) =>
    validatedGet(`elaborazioni${cassa ? `?cassa=${cassa}` : ''}`, ElaborazioniListResult),

  dettaglio: (id: number) =>
    validatedGet(`elaborazioni/${id}`, ElaborazioneResponseSchema),

  crea: (dati: { cassa: CassaCode; anno: number; mese: number; tipo?: string }) =>
    validatedPost('elaborazioni', dati, CreaResult),

  // Tipi di caricamento (multi-tipo). Array vuoto = cassa mono-tipo, niente
  // step di selezione tipo nel wizard.
  tipi: (cassa: CassaCode) =>
    validatedGet(`casse/${cassa}/tipi`, TipiCassaResult),

  elimina: (id: number) =>
    validatedDelete(`elaborazioni/${id}`, OkResult),

  cleanDir: (cassa: CassaCode) =>
    validatedDelete(`elaborazioni/clean-dir?cassa=${cassa}`, OkResult),

  uploadFenice: (id: number) =>
    apiPost<{ ok: true; id_job: number }>(`elaborazioni/${id}/upload-fenice`, {}),
};
